import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import cn from 'classnames';
import isEmpty from 'lodash.isempty';
import isString from 'lodash.isstring';

import { short } from '../../../pages/common/formatting/date';

const questionSort = (a, b) => {
	if (a.question_order < b.question_order) {
		return -1;
	}
	if (a.question_order > b.question_order) {
		return 1;
	}
	return 0;
};

const loadResponses = (care_quest_response_groupId) => (
	axios.get(`/care_quest_response_groups/${care_quest_response_groupId}/care_quest_responses`, {
		params: {
			filter: JSON.stringify({
				include: [{
					relation: 'care_quest_question',
					scope: {
						order: ['question_order'],
						include: 'care_quest_answers',
						scope: {
							order: ['answer_order']
						}
					}
				}]
			})
		}
	})
);
export default class Assessment extends React.Component {
	static propTypes = {
		assessment: PropTypes.object
	}

	state = {
		isLoading: true
	}

	componentDidMount() {
		loadResponses(this.props.assessment.id).then(({ data }) => {
			this.setState({
				care_quest_responses: data
			});
		}).finally(() => {
			this.setState({ isLoading: false });
		});
	}

	getAnswer = (question) => {
		const responses = this.state.care_quest_responses.filter(response => response.care_quest_questionId === question.id);
		const [response] = responses;
		if (question.question_type.indexOf('Multiple Select') >= 0) {
			return responses.map(response => {
				const answer = question.care_quest_answers.find(answer => answer.id === response.care_quest_answerId);
				return (
					<p key={response.id} className={cn({ 'negative-sentiment': answer.sentiment === 'Negative' })}>
						{answer.answer_text}
					</p>
				);
			});
		}
		if (response && isString(response.care_quest_answer_text)) {
			if (question.question_type === 'Date') {
				return (
					<p>{short(response.care_quest_answer_text)}</p>
				);
			}
			if (isEmpty(response.care_quest_answer_text.trim())) {
				return (<p><em>NO RESPONSE</em></p>);
			} else {
				return (<p>{response.care_quest_answer_text}</p>);
			}
		} else if (response && response.care_quest_answerId) {
			const answer = question.care_quest_answers.find(answer => answer.id === response.care_quest_answerId);
			if (answer) {
				return (
					<p className={cn({ 'negative-sentiment': answer.sentiment === 'Negative' })}>
						{answer.answer_text}
					</p>
				);
			}
		}
	}

	showQuestion = (question) => {
		const questionResponses = this.state.care_quest_responses.filter(response => response.care_quest_questionId === question.id);
		return questionResponses.length > 0;
	}

	render() {
		const { assessment } = this.props;
		const { isLoading, care_quest_responses } = this.state;
		if (isLoading) {
			return (
				<div>
					Loading...
				</div>
			);
		}
		// extract questions, get unique, sort
		if (!assessment || (!isLoading && (!care_quest_responses || care_quest_responses.length === 0))) {
			return (
				<div>
					No Assessment found
				</div>
			);
		}
		const questions = care_quest_responses.map(response => response.care_quest_question)
			.filter((q, index, self) => self.findIndex(el => el.id === q.id) === index);
		questions.sort(questionSort);
		return (
			<div>
				<ol>
					{questions.map(question => (
						question.conditional_parent_question_id ? (
							this.showQuestion(question) && (
								<ul key={question.id}>
									<li>
										<strong>{question.question_text}</strong><br />
										{this.getAnswer(question)}
									</li>
								</ul>
							)
						) : (
							<li key={question.id}>
								<strong>{question.question_text}</strong><br />
								{this.getAnswer(question)}
							</li>
						)
					))}
				</ol>
			</div>
		);
	}
}
